/**
 * Site / clinic post-auth landing.
 * Site Portal is the product home for site_clinic (and clinic/site aliases).
 * Synergy and scribe-only invites keep their existing specialized destinations.
 */

export const SITE_PORTAL_PATH = '/site-portal';
/** Site metrics live on the Site Portal Insights tab (real site data only, no benchmarks). */
export const SITE_INSIGHTS_PATH = '/site-portal?tab=insights';

/** Site Portal tab deep link. */
export const sitePortalTab = (tab) => `${SITE_PORTAL_PATH}?tab=${encodeURIComponent(tab)}`;

/** Blank/legacy dashboards and marketing pages must not be post-login homes. */
export const SITE_HOME_ALIASES = new Set([
  '/',
  '/clinic-management-dashboard',
  '/clinic-dashboard',
  '/clinics',
  '/clinics-hub',
  '/clinic-login',
  '/clinic-first-login',
]);

export const isSynergyPilotLogin = (profile) =>
  profile?.role === 'site_clinic' && String(profile?.email || '')?.trim()?.toLowerCase() === 'synergy@curegate.ai';

export function isSiteClinicRole(role) {
  const normalized = String(role || '').trim().toLowerCase();
  return normalized === 'site_clinic' || normalized === 'clinic' || normalized === 'site';
}

export function resolveSitePostLoginPath(profile = {}, modules = []) {
  if (isSynergyPilotLogin(profile)) {
    return '/synergy-pilot';
  }
  if (Array.isArray(modules) && modules.length === 1 && modules.includes('has_scribe_access')) {
    return '/oncoecho-scribe-session';
  }
  return SITE_PORTAL_PATH;
}

/**
 * After site/clinic auth, land on the Site Portal hub unless a real deep link
 * was requested. Clinic Management Dashboard is never the post-login home.
 */
export function resolveSiteReturnPath(requestedPath, profile = {}, modules = []) {
  const home = resolveSitePostLoginPath(profile, modules);
  if (home !== SITE_PORTAL_PATH) return home;
  if (!requestedPath || typeof requestedPath !== 'string') return home;
  const path = requestedPath.split('?')[0];
  if (!path.startsWith('/') || SITE_HOME_ALIASES.has(path) || path === SITE_PORTAL_PATH) {
    return home;
  }
  return path;
}
